import { render, staticRenderFns } from "./Actus.vue?vue&type=template&id=0b6568f3&"
import script from "./Actus.vue?vue&type=script&lang=ts&"
export * from "./Actus.vue?vue&type=script&lang=ts&"
import style0 from "./Actus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports